import { Button, IconButton, useMediaQuery } from "@mui/material";
import { theme } from "../../theme";
import { MenuRounded } from "@mui/icons-material";
import { useMemo } from "react";
import { getAuth } from "firebase/auth";
import { ReactComponent as ShareStroked } from "../../assets/icons/ShareStroked.svg";
import { openAuthModal } from "../../redux/slices/userSlice";
import { AppDispatch } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as SignalStroke } from "../../assets/icons/SignalStroke.svg";
import { setWatchlistDrawerState } from "../../redux/slices/watchlistSlice";
import { logClickEvent } from "../../analytics";
import { useOutletContext } from "react-router-dom";
import { MainLayoutType } from "../../assets/interfaces/interfaces";
import { AuthActions } from "../Sidebar/constants";
import QuotaMeter from "../QuotaMeter";

type NavbarProps = {
  showShareChatIcon: boolean;
  setShareModal: (value: boolean) => void;
};
const Navbar = ({ showShareChatIcon, setShareModal }: NavbarProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const auth = getAuth();

  const dispatch = useDispatch<AppDispatch>();

  const isUserSignedIn = useMemo(() => {
    return !!auth?.currentUser;
  }, [auth?.currentUser]);
  const { isWatchlistDrawerOpen } = useSelector(
    (state: { watchlist }) => state.watchlist,
  );

  const { isSidebarExpanded, setIsSidebarExpanded } = useOutletContext<MainLayoutType>();

  return (
    <header
      className={`${
        isMobile ? "justify-between" : "justify-start"
      } px-6 py-1.5 md:pt-6 gap-5 sticky top-0 flex items-center z-10 font-semibold border-b border-token-border-medium md:border-transparent bg-token-surface-primary dark:bg-background/paper-elevation-1`}
    >
      {!!isMobile && (
        <div className="toggle-drawer-button !items-start">
          <IconButton
            onClick={() => setIsSidebarExpanded(!isSidebarExpanded)}
            className="!text-token-text-primary"
          >
            <MenuRounded />
          </IconButton>
        </div>
      )}
      {!isUserSignedIn && (
        <Button
          onClick={() => {
            dispatch(openAuthModal({ type: AuthActions.SIGNUP }));
          }}
          classes={{
            root: `upgrade-plan-button !w-[90px]`,
          }}
        >
          Sign Up
        </Button>
      )}
      <div className="ml-auto flex items-center gap-2">
        <QuotaMeter />
        {showShareChatIcon && (
          <Button
            variant="outlined"
            color="inherit"
            size="medium"
            className="button-outlined"
            onClick={() => setShareModal(true)}
            sx={{
              minWidth: "36px",
              minHeight: "36px",
              padding: 0,
            }}
          >
            <ShareStroked className="h-6 w-6" />
          </Button>
        )}
      </div>
      <div>
        {!isWatchlistDrawerOpen
        && (isMobile
          ? (
              <IconButton
                size="small"
                className="cross-icon"
                onClick={() =>
                  dispatch(setWatchlistDrawerState(true))}
              >
                <SignalStroke />
              </IconButton>
            )
          : (
              <Button
                variant="outlined"
                color="inherit"
                size="medium"
                className="button-outlined"
                onClick={() => {
                  dispatch(setWatchlistDrawerState(true));
                  logClickEvent("watchlist_click");
                }}
              >
                <div className="flex gap-x-1">
                  <SignalStroke />
                  Watchlist
                </div>
              </Button>
            ))}
      </div>
    </header>
  );
};

export default Navbar;
